import React from 'react';

type UseReview = (
  courseId?: string | null,
) => {
  isValidReview: boolean;
  updateCacheLastTimeReview: () => void;
};
export const useReview: UseReview = (courseId) => {
  const [isValid, setIsValid] = React.useState(false);

  React.useEffect(() => {
    if (!courseId) {
      return;
    }
    try {
      const objString = localStorage.getItem('lastReviewTime') || '{}';
      const json = JSON.parse(objString);
      const lastTime = json[courseId] || 0;
      const currentTime = new Date().getTime();
      if (currentTime - lastTime > 5 * 60 * 60 * 1000) {
        setIsValid(true);
      }
    } catch (error) {
      setIsValid(true);
    }
  }, [courseId]);

  function updateCacheLastTimeReview() {
    if (!courseId) {
      return;
    }
    try {
      const objString = localStorage.getItem('lastReviewTime') || '{}';
      const json = JSON.parse(objString);
      json[courseId] = new Date().getTime();
      localStorage.setItem('lastReviewTime', JSON.stringify(json));
      setIsValid(false);
    } catch (error) {
      localStorage.setItem(
        'lastReviewTime',
        JSON.stringify({
          courseId: new Date().getTime(),
        }),
      );
      setIsValid(false);
    }
  }

  return {
    isValidReview: isValid,
    updateCacheLastTimeReview,
  };
};
